<!-- <template>
  <div
    class="ui steps"
    :class="{ordered: ordered}"
  >
    <div
      v-for="step in steps"
      :key="step.index"
      class="step"
      :class="{completed: step.completed, active: step.active, disabled: step.disabled}"
      @click="$emit(`click${step.index}`)"
    >
      <div class="content">
        <p class="title">{{step.title}}</p>
        <p
          v-if="step.description"
          class="description"
        >{{step.description}}</p>
      </div>
    </div>
  </div>
</template> -->

<template>
	<div class="ui ordered steps">
		<slot />
	</div>
</template>

<script>
export default {
	props: {
		ordered: {
			type: Boolean,
			default: false,
		},
	},
}
</script>

<style>
.ui.ordered.steps {
	position: relative;
	width: 100%;
}

.ui.ordered.steps .step {
	width: min-content;
	padding: 1.5em 1em !important;
	min-height: auto !important;
}

.ui.ordered.steps .step:before {
	font-size: 1.2rem;
	background-color: transparent !important;
	color: rgb(var(--color-primary)) !important;
	font-weight: bold;
	position: static !important;
	margin-right: 0.5em;
	vertical-align: top;
}

.ui.ordered.steps .step.active:before,
.ui.ordered.steps .step.completed:before {
	background-color: transparent !important;
	color: rgb(var(--color-primary)) !important;
}

.ui.steps .step:first-child {
	padding-left: 1em;
	border-radius: 0.28571429rem 0 0 0.28571429rem;
}

.ui.step,
.ui.steps .step {
	font-size: 0.75rem;
	cursor: pointer;
}

.ui.steps .step .title {
	font-size: 0.875rem !important;
	line-height: 1.2rem !important;
	margin: 0 !important;
}

.ui.steps .step .description {
	font-size: 0.65rem !important;
	line-height: 0.9rem !important;
	margin: 0 !important;
}

.ui.steps .step p {
	line-height: 0.9rem;
	margin-bottom: 0;
}

@media screen and (min-device-width: 1200px) and (max-device-width: 1600px) and (-webkit-min-device-pixel-ratio: 1) {
	.ui.ordered.steps .step:before {
		font-size: 1rem;
	}

	.ui.step,
	.ui.steps .step {
		font-size: 0.6rem;
	}

	.ui.steps .step .title {
		font-size: 0.9rem !important;
	}
}
</style>
